// src/utils/sixDetail.utils.ts
import type { ParticipantsResponse, SixActivity } from '@/types/SixDetail.types';

export const ACTIVITY_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

export function getMembersCount(participants?: ParticipantsResponse): number {
  if (participants === undefined) return 0;

  return (
    participants.owners.length +
    participants.internalParticipants.length +
    participants.externalParticipants.length
  );
}

export function getLastActivityLabel(activities?: SixActivity[]): string {
  if (activities === undefined || activities.length === 0) return '-';

  const sortedActivities = [...activities].sort(
    (firstActivity, secondActivity) =>
      secondActivity.timestamp.getTime() - firstActivity.timestamp.getTime(),
  );

  const latestActivity = sortedActivities[0];

  if (Number.isNaN(latestActivity.timestamp.getTime())) return '-';

  return latestActivity.timestamp.toLocaleString('en-US', ACTIVITY_DATE_FORMAT);
}
